import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import {
  IDataSourceRequest,
  IDataSourceResult,
  Provider,
  CreateOrUpdateProvider,
  RegisterProvider,
  UpdateProfileProvider,
  ProfileProvider,
  AdminCreateOrUpdateProvider,
  LookupModel,
} from '../models';
import { HelperService } from './helper.service';

@Injectable({ providedIn: 'root' })
export class ProviderService {
  url = '/providers';
  request: IDataSourceRequest;

  constructor(private apiService: ApiService, private helperService: HelperService) {
    this.request = Object.assign({}, this.helperService.request);
  }

  get(): Observable<IDataSourceResult<Provider>> {
    return this.apiService.post(`${this.url}/search`, this.request).pipe(map(data => data.data));
  }

  getById(id: number): Observable<Provider> {
    return this.apiService.get(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  create(model: AdminCreateOrUpdateProvider): Observable<void> {
    return this.apiService.post(this.url, model).pipe(map(data => data.data));
  }

  update(id: number, model: AdminCreateOrUpdateProvider): Observable<void> {
    return this.apiService.put(this.url, id.toString(), model).pipe(map(data => data.data));
  }

  delete(id: number): Observable<void> {
    return this.apiService.delete(`${this.url}/${id}`).pipe(map(data => data.data));
  }

  register(model: RegisterProvider): Observable<any> {
    return this.apiService.post(`${this.url}/register`, model).pipe(map(data => data.data));
  }

  getProfile(): Observable<ProfileProvider> {
    return this.apiService.get(`${this.url}/profile`).pipe(map(data => data.data));
  }

  updateProfile(model: UpdateProfileProvider): Observable<boolean> {
    return this.apiService.post(`${this.url}/update-provider`, model).pipe(map(data => data.data));
  }

  getDDL(): Observable<LookupModel[]> {
    return this.apiService.get(`${this.url}/get-ddl`).pipe(map(data => data.data));
  }

  exportProvidersExcel(): Observable<any> {
    return this.apiService
      .postWithReponseArrayBuffer(`${this.url}/export-providers-excel/`, this.request)
      .pipe(map(data => data));
  }
}
